// HomeBanner.js
import React from "react";
import Slider from "react-slick";
import "./HomeBanner.css";
import slide1 from "./assets/Banner01.gif";
import slide2 from "./assets/Banner02.gif";
import slide3 from "./assets/Banner03.gif";
import slide4 from "./assets/Banner04.gif";
import slide5 from "./assets/Banner05.gif";
import slide6 from "./assets/Banner06.gif";

const HomeBanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: true, // Enable arrows
    prevArrow: <CustomPrevArrow />, // Custom Previous Arrow
    nextArrow: <CustomNextArrow />, // Custom Next Arrow
  };

  return (
    <>
      <div className="home-banner-container mt-3">
        <Slider {...settings}>
          <div className="slider-item">
            <img src={slide1} alt="Slide 1" className="slider-image" />
          </div>
          <div className="slider-item">
            <img src={slide2} alt="Slide 2" className="slider-image" />
          </div>
          <div className="slider-item">
            <img src={slide3} alt="Slide 3" className="slider-image" />
          </div>
          <div className="slider-item">
            <img src={slide4} alt="Slide 4" className="slider-image" />
          </div>
          <div className="slider-item">
            <img src={slide5} alt="Slide 5" className="slider-image" />
          </div>
          <div className="slider-item">
            <img src={slide6} alt="Slide 6" className="slider-image" />
          </div>
          
        </Slider>
      </div>

    </>
  );
};

const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="custom-arrow prev-arrow" onClick={onClick}>
      &#8592;
    </button>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button className="custom-arrow next-arrow" onClick={onClick}>
      &#8594;
    </button>
  );
};

export default HomeBanner;
